const translations = {
  "en": {
    "More Questions": "More Questions"
  },
  "zh-tw": {
    "More Questions": "更多問題"
  }
};

export default translations;
